import store from './store/store.js'

const routes = [{
    path: '/',
        component: resolve => require(['./default.vue'], resolve),
    children: [
        {
            path: 'noItems',
            component: resolve => require(['./components/pages/noItems.vue'], resolve),
            meta: {
                title: 'CIRCA | No Active Tenders',                
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login')}},             
        },
        {
            path: '',
            component: resolve => require(['./components/pages/home.vue'], resolve),
            meta: {
                title: 'CIRCA',                
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login')}},             
        },
        {
            path: 'product_gallery',
            component: resolve => require(['./components/pages/product_gallery.vue'], resolve),
            meta: {
                title: 'CIRCA | Gallery',                
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login')}},             
        },
        
        {
            path: 'diamonds',
            component: resolve => require(['./components/pages/product_gallery.vue'], resolve),
            meta: {
                title: 'CIRCA | Diamonds Gallery',                
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login')}},             
        },
        {
            path: 'jewelry',
            component: resolve => require(['./components/pages/product_gallery.vue'], resolve),
            meta: {
                title: 'CIRCA | Jewelry Gallery',                
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login')}},             
        },
        {
            path: 'watches',
            component: resolve => require(['./components/pages/product_gallery.vue'], resolve),
            meta: {
                title: 'CIRCA | Watches Gallery',                
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login')}},             
        },
        {
            path: 'cart',
            component: resolve => require(['./components/pages/ecommerce/cart.vue'], resolve),
            meta: {
                title: 'CIRCA | My Cart',                
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login?redirect=cart')}},             
        },
        {
            path: 'manageusers',
            component: resolve => require(['./components/pages/manageusers.vue'], resolve),
            meta: {
                title: 'Manage Users',
                breadcrumb: [{
                    html: '<i class="ti-home"></i> Home',
                    href: '/',
                },{
                    html: 'Manage Users',
                    href: '/manageusers',
                }]
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login')}},             
        },
        {
            path: 'tos',
            component: resolve => require(['./components/pages/TOS.vue'], resolve),
            meta: {
                title: 'TOS',
                breadcrumb: [{
                    html: '<i class="ti-home"></i> Home',
                    href: '/',
                },{
                    html: 'TOS',
                    href: '/tos',
                }]
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login?redirect=tos')}},             
        },
        {
            path: 'faq',
            component: resolve => require(['./components/pages/FAQ.vue'], resolve),
            meta: {
                title: 'FAQ',
                breadcrumb: [{
                    html: '<i class="ti-home"></i> Home',
                    href: '/',
                },{
                    html: 'FAQ',
                    href: '/faq',
                }]
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login?redirect=faq')}},             
        },
        {
            path: 'myaccount',
            component: resolve => require(['./components/pages/myaccount.vue'], resolve),   
            meta: {
                title: 'My Account',
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login?redirect=myaccount')}},             
        },
        {
            path: 'mydashboard',
            component: resolve => require(['./components/pages/mydashboard.vue'], resolve),
            meta: {
                title: 'My Dashboard',
                breadcrumb: [{
                    html: '<i class="ti-home"></i> Home',
                    href: '/',
                },{
                    html: 'My Dashboard',
                    href: '/mydashboard',
                }]
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login?redirect=mydashboard')}},             
        },
        {
            path: 'mydashboarda',
            component: resolve => require(['./components/pages/mydashboarda.vue'], resolve),
            meta: {
                title: 'Admin Dashboard',
                breadcrumb: [{
                    html: '<i class="ti-home"></i> Home',
                    href: '/',
                },{
                    html: 'Admin Dashboard',
                    href: '/mydashboarda',
                }]
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login')}},             
        },
        {
            path: 'product_details/:id',
            component: resolve => require(['./components/pages/product_details.vue'], resolve),
            meta: {
                title: 'Product Details',            
            }
            ,beforeEnter (to, from, next) {if (store.state.auth.idToken) {next()  } else {next('/login?redirect='+to.fullPath)}},             
        }, 
        {
        path: 'blank',
        component: resolve => require(['./components/pages/blank.vue'], resolve),
        meta: {
            title: 'Blank',
            breadcrumb: [{
                html: '<i class="ti-home"></i> Dashboard',
                href: '/',
            }, {
                html: 'Extra Pages',
                href: '#',
            }, {
                html: 'Blank',
                href: '/blank'
            }]
        }
    }, {
        path: 'mini_sidebar',
        component: resolve => require(['./components/pages/mini_sidebar.vue'], resolve),
        meta: {
            title: 'Mini Sidebar',
            breadcrumb:[{
                html:'<i class="ti-home"></i> Dashboard',
                href:'/',
            },{
                html:'Layouts',
                href:'#',
            },{
                html:'/mini_sidebar'
            }]
        }
    },
    {
        path: 'user_profile',
        component: resolve => require(['./components/pages/user_profile.vue'], resolve),
        meta: {
            title: 'User Profile',
            breadcrumb: [{
                html: '<i class="ti-home"></i> Dashboard',
                href: '/',
            }, {
                html: 'Users',
                href: '#',
            }, {
                html: 'User Profile',
                href: '/user_profile'
            }]
        }
    },{
        path: 'edit_user',
        component: resolve => require(['./components/pages/edit_user.vue'], resolve),
        meta: {
            title: 'Edit User',
            breadcrumb: [{
                html: '<i class="ti-home"></i> Dashboard',
                href: '/',
            }, {
                html: 'Users',
                href: '#',
            }, {
                html: 'Edit User',
                href: '/edit_user'
            }]
        }
    }]
}, 
{
    path: '/confirmTAS',
    component: resolve => require(['./components/pages/confirmTAS.vue'], resolve),
    meta: {
        title: 'Terms of Service Confirmation',
        breadcrumb: ``
    }
},
{
    path: '/500',
    component: resolve => require(['./components/pages/500.vue'], resolve),
    meta: {
        title: '500',
        breadcrumb: ``
    }
}, {
    path: '/login',
    component: resolve => require(['./components/pages/login.vue'], resolve),
    meta: {
        title: 'Login',
        breadcrumb: ``
    },        
}, {
    path: '/register',
    component: resolve => require(['./components/pages/register.vue'], resolve),
    meta: {
        title: 'Register',
        breadcrumb: ``
    }
}, {
    path: '/lockscreen',
    component: resolve => require(['./components/pages/lockscreen.vue'], resolve),
    meta: {
        title: 'Lockscreen',
        breadcrumb: ``
    }
}, {
    path: '/forgot_password',
    component: resolve => require(['./components/pages/forgot_password.vue'], resolve),
    meta: {
        title: 'Forgot Password',
        breadcrumb: ``
    }
}, {
    path: '*',
    component: resolve => require(['./components/pages/404.vue'], resolve),
    meta: {
        title: '404',
        breadcrumb: ``
    }
},
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js